import { PureComponent } from "react";
import { componentStyles } from "./hero-image-component.scss";
import Dimensions from "constants/dimensions";

import PictureComponent from "components/core/picture/picture-component";
import TextAndAssetComponent from "components/segments/text-and-asset/text-and-asset-component";

export default class HeroImageComponent extends PureComponent {
  constructor(props) {
    super(props);
  }

  getComponentStyles() {
    const { height } = this.props;

    return {
      height: `calc(${height} - ${Dimensions.TOP_BAR_HEIGHT}px)`
    };
  }

  render() {
    const { halfMoonWidth, textAndAssets, heroImage } = this.props;
    const { src, alt } = heroImage;
    const styles = this.getComponentStyles();

    return (
      <div className="hero-image-component" style={styles}>
        <PictureComponent pictureClass="hero-image" src={src} alt={alt} />

        <div className="text-and-assets-background" style={{ left: `calc(-180vh + ${halfMoonWidth})` }} />

        <div className="text-and-assets-component-wrapper">
          <TextAndAssetComponent {...textAndAssets} />
        </div>

        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}

HeroImageComponent.defaultProps = {
  height: "100vh",
  halfMoonWidth: "40vw",
  heroImage: {}
};
